import React from 'react';

import Icon from '../icon/icon';
import { LoaderContainer } from './loader.styled';

interface LoaderProps {
  size?: string;
  type?: 'standard' | 'pata';
  addPadding?: boolean;
}

export function Loader({ size = '150px', type = 'pata', addPadding = true }: LoaderProps) {
  return (
    <LoaderContainer $addPadding={addPadding}>
      <Icon size={size} type={'LoadingIcon'} />
    </LoaderContainer>
  );
}
